import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "🚀", key: "yes" },
  { emoji: "👀", key: "showMe" },
  { emoji: "💪", key: "almost" },
]

export default function ReadyToTransformPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="readyToTransformHomeDesign"
        options={OPTIONS}
        subtitle="subtitle"
      />
    )
  }
  return (
    <RadioCardListPage
      translationKey="readyToTransform"
      options={OPTIONS}
      subtitle="subtitle"
    />
  )
}
